export default "__VITE_ASSET__BROU_g54__"